import { TextareaInputField } from "@/components/shared";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const additionalSchema = z.object({
  additionalText: z.string().optional().or(z.literal("")),

});

export const additionalDefaultValues = {
  additionalText: ""
};

export function AdditionalFormGroup({ form }: { form: UseFormReturn<any> }) {
  const { t } = useTranslation();

  return (
    <div>
      <div id="additional" className="form-field-container">
        {/* additionalText */}
        <TextareaInputField
          form={form}
          name="additionalText"
          label={t("newtender.formgroups.additionaltext.inputs.additional.label")}
          placeholder={t("newtender.formgroups.additionaltext.inputs.additional.label")}
        />
      </div>
    </div>
  );
}
